import { client } from './api';

export type AgencyConfigPayload = {
  agency_id: string;
  intake_manager_columns: string[] | null;
};

export async function getAgencyConfig(): Promise<AgencyConfigPayload> {
  const res = await client.get({
    url: '/agency-config',
    responseType: 'json',
  });
  return res.data as AgencyConfigPayload;
}

export async function updateAgencyConfig(body: {
  intake_manager_columns: string[] | null;
}): Promise<AgencyConfigPayload> {
  const res = await client.put({
    url: '/agency-config',
    body,
    responseType: 'json',
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return res.data as AgencyConfigPayload;
}
